import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditAccountFeeComp from "./Component/EditAccountFeeComp"


const EditAccountFee =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditAccountFeeComp />
        </div>
        <Footer />
        </>
    )
}

export default EditAccountFee